import type { InputHTMLAttributes, ReactNode } from 'react';

export interface SwitchProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'role'> {
  label: ReactNode;
  hideLabel?: boolean;
}

/**
 * Accessible toggle switch (`role="switch"`). Styled with `pn-switch` tokens.
 */
export function Switch({
  label,
  hideLabel = false,
  className,
  id,
  ...rest
}: SwitchProps) {
  const inputId =
    id ?? `pn-switch-${typeof label === 'string' ? label.replace(/\s+/g, '-').toLowerCase() : 'field'}`;

  return (
    <label
      className={['pn-switch', className].filter(Boolean).join(' ')}
      data-disabled={rest.disabled ? 'true' : undefined}
    >
      <input
        {...rest}
        id={inputId}
        type="checkbox"
        role="switch"
        className="pn-switch-input"
      />
      <span className="pn-switch-track" aria-hidden="true" />
      <span
        className={
          hideLabel ? 'pn-field-label-hidden' : 'pn-switch-label'
        }
      >
        {label}
      </span>
    </label>
  );
}
